export const LoadingActionTypes = {
  SetForegroundTaskAction: "LOADING_SET_FOREGROUND_TASK",
  SetStatusAction: "LOADING_SET_STATUS",
  RevertStateAction: "LOADING_REVERT_STATE",
  SetPercentDoneAction: "LOADING_SET_PERCENT_DONE"
};

export enum LoadingStatus {
  LoadingTranscription,
  UploadingFile,
  TranscribingAudio,
  StorageMigrationInProgress,
  StorageMigrationCompleted,
  WaitForConnection
}